import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Desktop16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M13.5 2C14.3284 2 15 2.67157 15 3.5V7.875C15 8.42728 14.5523 8.875 14 8.875L2 8.875C1.44772 8.875 1 8.42728 1 7.875V3.5C1 2.67157 1.67157 2 2.5 2H13.5ZM1.375 10.125C1.16789 10.125 1 10.2929 1 10.5V10.5C1 11.3284 1.67157 12 2.5 12H6.31254C6.69224 12 7.00004 12.3078 7.00004 12.6875C7.00004 13.0672 6.69224 13.375 6.31254 13.375H4C3.65482 13.375 3.375 13.6548 3.375 14C3.375 14.3452 3.65482 14.625 4 14.625L12 14.625C12.3452 14.625 12.625 14.3452 12.625 14C12.625 13.6548 12.3452 13.375 12 13.375H9.68754C9.30785 13.375 9.00004 13.0672 9.00004 12.6875C9.00004 12.3078 9.30785 12 9.68754 12H13.5C14.3284 12 15 11.3284 15 10.5V10.5C15 10.2929 14.8321 10.125 14.625 10.125L1.375 10.125Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
